import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { parseDate } from 'utils';

interface InvoiceHeaderProps {
  invoiceData?: {
    date?: string;
    serialNo?: string;
    invoiceNo?: string;
  };
}

const styles = {
  header: {
    textAlign: 'center' as const,
    marginBottom: 10,
    borderBottom: '1px solid black',
    paddingBottom: 8
  },
  invoiceTitle: {
    fontSize: 16,
    fontWeight: 'bold' as const,
    color: '#eb0103',
    marginBottom: 2
  },
  invoiceSubtitle: {
    fontSize: 10,
    marginBottom: 4
  },
  textBold: {
    fontWeight: 700
  }
};

const InvoiceHeader: React.FC<InvoiceHeaderProps> = ({ invoiceData }) => {
  const { day, month, year } = parseDate(invoiceData?.date);

  return (
    <>
      <View style={styles.header}>
        <Text style={styles.invoiceTitle}>HÓA ĐƠN GIÁ TRỊ GIA TĂNG</Text>
        <Text style={{ ...styles.invoiceSubtitle, color: '#eb0103', fontSize: 12 }}>
          (VAT INVOICE)
        </Text>
        <View style={{ flexDirection: 'row', width: '100%' }}>
          <View style={{ flex: 1, alignItems: 'center', left: 90 }}>
            <Text style={styles.invoiceSubtitle}>(Bản thể hiện của hóa đơn điện tử)</Text>
            <Text style={styles.invoiceSubtitle}>(Electronic invoice display)</Text>
          </View>

          <View style={{ width: 180, textAlign: 'left', left: 50 }}>
            <View style={{ flexDirection: 'row' }}>
              <Text style={{ ...styles.invoiceSubtitle, right: 20 }}>Ký hiệu (Serial No.): </Text>
              <Text style={{ ...styles.invoiceSubtitle, ...styles.textBold, right: 20 }}>
                {invoiceData?.serialNo}
              </Text>
            </View>
            <View style={{ flexDirection: 'row' }}>
              <Text style={{ ...styles.invoiceSubtitle, right: 20 }}>Số (No.): </Text>
              <Text style={{ color: '#cc0000', fontWeight: 'bold', right: 20 }}>
                {invoiceData?.invoiceNo}
              </Text>
            </View>
          </View>
        </View>

        <Text style={styles.invoiceSubtitle}>
          Ngày (date) {day} tháng (month) {month} năm (year) {year}
        </Text>
      </View>
    </>
  );
};

export default InvoiceHeader;
